import {
  getPlatformExecuteAdHocQueryTeamMockHandler,
  getPlatformExecuteAdHocQueryTeamResponseMock,
} from 'shared/base';
import { resourceCategoriesSQLQuery } from 'shared/domains/assetsInventory';

import adhocQueryForResourceCategories from './data/adhocQueryForResourceCategories.json';

export const getCustomPlatformExecuteAdHocQueryTeamMockHandler = () => {
  return getPlatformExecuteAdHocQueryTeamMockHandler(async (info) => {
    const body = await info.request.json();

    if ((body as any)?.query === resourceCategoriesSQLQuery) {
      return { data: adhocQueryForResourceCategories } as any;
    }

    return getPlatformExecuteAdHocQueryTeamResponseMock();
  });
};
